var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBgLeft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 889,
    height: 900,
    viewBox: "0 0 889 900",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "94.254%",
    y1: "11.624%",
    x2: "63.854%",
    y2: "90.514%",
    id: "1gls1jzxoa"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A1C5",
    stopOpacity: 0.035,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A1C5",
    stopOpacity: 0.05,
    offset: "39.244%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A1C5",
    stopOpacity: 0,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.03 0H.277v392.128z",
    fill: "#35A1C5",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.864 0 .708 898.003H888.72z",
    transform: "matrix(-1 0 0 1 889 .998)",
    fill: "url(#1gls1jzxoa)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBgLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bg-left.2a35c3b985849de12ad1c07bd9945398.svg";